export default function NotFound() {
  return (
    <div className="flex p-40 flex-col items-center justify-center h-full text-center text-gray-600">
      <h1 className="text-6xl font-bold mb-4">404</h1>
      <p className="text-xl mb-8">Pagina non trovata</p>
      <a
        href="/dashboard"
        className="text-blue-600 hover:underline"
      >
        Torna alla Dashboard
      </a>
    </div>
  );
}
